import React, { memo, useMemo, useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useForm } from "react-hook-form";
import styled from "@emotion/styled";

import { Button, SmallButton } from "@/components/Buttons";
import Modal from "@/components/Modal";
import Table from "@/components/Table";
import { useCorpUsersStore } from "@/store/hooks";

const CorpUsersTable = styled(Table)``;

const Title = styled.h3`
  margin: 0;
`;

const SearchButtonColumn = styled(Col)`
  text-align: right;
`;

const SelectColumn = memo(({ corpUser, onSelect }) => {
  function handleClick() {
    onSelect(corpUser);
  }

  return <SmallButton onClick={handleClick}>선택</SmallButton>;
});

const FindCorpUserModal = ({ onSelect }) => {
  const [corpTitleQuery, setCorpTitleQuery] = useState("");

  const { state, ...actions } = useCorpUsersStore();
  const { register, handleSubmit } = useForm();

  useEffect(() => {
    actions.fetchAll();
  }, []);

  function handleGoToPage(page) {
    actions.fetchAll({
      corpTitle: corpTitleQuery,
      page,
      pageSize: state.pageSize,
    });
  }

  function handleNextPage() {
    actions.fetchAll({ corpTitle: corpTitleQuery, page: state.page + 1 });
  }

  function handlePreviousPage() {
    actions.fetchAll({ corpTitle: corpTitleQuery, page: state.page - 1 });
  }

  function handleSetPageSize(pageSize) {
    actions.fetchAll({ corpTitle: corpTitleQuery, page: 1, pageSize });
  }

  const onSubmit = async ({ corpTitle = "" }) => {
    setCorpTitleQuery(corpTitle);

    actions.fetchAll({
      corpTitle,
      page: 1,
      pageSize: state.pageSize,
    });
  };

  const columns = useMemo(
    () => [
      {
        Header: "id",
        accessor: "id",
        width: 80,
      },

      {
        Header: "회원 ID",
        accessor: "username",
      },
      {
        Header: "회사명",
        accessor: "corpTitle",
        width: 120,
      },
      {
        Header: "선택",
        accessor: (row) => <SelectColumn corpUser={row} onSelect={onSelect} />,
        selectable: false,
        width: 75,
      },
    ],
    [],
  );

  return (
    <Modal>
      <Modal.Header>
        <Title>기업회원 검색하기</Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group as={Row}>
            <Col md={6}>
              <Form.Control
                name="corpTitle"
                placeholder="기업회원 회사명"
                ref={register}
              />
            </Col>
            <SearchButtonColumn md={6}>
              <Button type="submit">검색하기</Button>
            </SearchButtonColumn>
          </Form.Group>
        </Form>
        <CorpUsersTable
          checkbox={false}
          responsive
          bordered
          columns={columns}
          currentPage={state.page}
          data={state.corpUsers}
          pageCount={state.pageCount}
          pageSize={state.pageSize}
          goToPage={handleGoToPage}
          nextPage={handleNextPage}
          previousPage={handlePreviousPage}
          setPageSize={handleSetPageSize}
        />
      </Modal.Body>
    </Modal>
  );
};

export default FindCorpUserModal;